document.addEventListener("DOMContentLoaded", function () {
    function copySelectedValue(targetId) {
        var element = document.getElementById(targetId);
        if (!element) {
            console.error("Element not found:", targetId);
            return;
        }

        var textToCopy = "";

        if (element.tagName === "SELECT") {
            // Handle dropdown
            var selectedOption = element.options[element.selectedIndex];
            textToCopy = selectedOption.textContent || selectedOption.innerText;

            // Extract only the part after the LAST hyphen
            textToCopy = textToCopy.includes(" - ") ? textToCopy.split(" - ").pop().trim() : textToCopy.trim();

        } else if (element.tagName === "INPUT" || element.tagName === "TEXTAREA") {
            // Handle text input or textarea
            textToCopy = element.value.trim();
        }

        if (navigator.clipboard) {
            navigator.clipboard.writeText(textToCopy).then(function () {
                toastr.success("Copied: " + textToCopy, "Success");
            }).catch(function (err) {
                console.error("Clipboard copy failed:", err);
                toastr.error("Failed to copy", "Error");
            });
        } else {
            // Fallback for older browsers
            var textArea = document.createElement("textarea");
            textArea.value = textToCopy;
            document.body.appendChild(textArea);
            textArea.select();
            try {
                document.execCommand("copy");
                toastr.success("Copied: " + textToCopy, "Success");
            } catch (err) {
                console.error("Clipboard copy failed:", err);
                toastr.error("Failed to copy", "Error");
            }
            document.body.removeChild(textArea);
        }
    }

    // Attach event listeners to all copy buttons
    document.querySelectorAll(".copy-btn").forEach(function (button) {
        button.addEventListener("click", function () {
            var targetId = this.getAttribute("data-target");
            copySelectedValue(targetId);
        });
    });
});
